import {
	UpdateServiceUnit,
} from './mutation-types.js'

import {setStore, getStore} from '../config/util'

export default {
	// 紀錄系統類別
	[UpdateServiceUnit](state, ServiceUnit) {
		state.ServiceUnit = ServiceUnit;
	},
}
